import { type App } from '~/app';

import { defineAsyncComponent } from 'vue';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Scroll To Card Component');
    app.vueApp.component(
        'scroll-to-card',
        defineAsyncComponent(async () => import('./ScrollToCard.vue'))
    );
};